import InvitationsRecords from '../pages/InvitationsRecords';
import ReferralProgram from '../pages/ReferralProgram';
import ReferralProgramWeb from '../pages/ReferralProgramWeb';
import InviteCode from '../pages/InviteCode';
import InviteQRCode from '../pages/InviteQRCode';
import TaxDeclaration from '../pages/TaxDeclaration';
import RewardDetails from '../pages/RewardDetails';
import Pay from '../pages/Pay';
import PayCard from '../pages/PayCard';
import PaySuccess from '../pages/PaySuccess';
import WithdrawalRecords from '../pages/WithdrawalRecords';
import CashOut from '../pages/CashOut';
import PayBill from '../pages/PayBill';
import Login from '../pages/login/Login';
import SignUp from '../pages/login/SignUp';
import VerificationCode from '../pages/login/VerificationCode';
import Verification from '../pages/verification/Verification';
import EnterCode from '../pages/verification/EnterCode';
import VerificationSuccess from '../pages/verification/VerificationSuccess';
import VerificationResult from '../pages/verification/VerificationResult';
import PendingOrders from '../pages/verification/PendingOrders';
import VerificationHistory from '../pages/verification/VerificationHistory';
import SignUpInviteCode from '../pages/login/SignUpInviteCode';
import WithdrawList from '../pages/WithdrawList';
import WithdrawDetail from '../pages/WithdrawDetail';
import { Navigate } from 'react-router-dom';

// 定义路由配置
export const routes = {
  public: [
    {
      path: '/campaigns/invitations/login',
      element: <Login />
    },
    {
      path: '/campaigns/invitations/signup',
      element: <SignUp />
    },
    {
      path: '/campaigns/invitations/verification',
      element: <VerificationCode />
    },
    {
      path: '/campaigns/invitations/refer-and-earn',
      element: <ReferralProgramWeb />
    },
    {
      path: '/campaigns/invitations/signup-invite-code',
      element: <SignUpInviteCode />
    },
    {
      path: '/campaigns/invitations-unlogged',
      element: <Navigate to="/campaigns/invitations/refer-and-earn" replace />
    }
  ],
  private: [
    {
      path: '/campaigns/invitations/',
      element: <ReferralProgram  />
    },
    {
      path: '/campaigns/invitations',
      element: <ReferralProgram />
    },
    {
      path: '/campaigns/invitations/invitations-records',
      element: <InvitationsRecords />
    },
    {
      path: '/campaigns/invitations/invite-code',
      element: <InviteCode />
    },
    {
      path: '/campaigns/invitations/invite-qr',
      element: <InviteQRCode />
    },
    {
      path: '/campaigns/invitations/tax-declaration',
      element: <TaxDeclaration />
    },
    {
      path: '/campaigns/invitations/reward-details',
      element: <RewardDetails />
    },
    {
      path: '/campaigns/invitations/pay',
      element: <Pay />
    },
    {
      path: '/campaigns/invitations/pay-card',
      element: <PayCard />
    },
    {
      path: '/campaigns/invitations/pay-success',
      element: <PaySuccess />
    },
    {
      path: '/campaigns/invitations/withdrawal-records',
      element: <WithdrawalRecords />
    },
    {
      path: '/campaigns/invitations/cash-out',
      element: <CashOut />
    },
    {
      path: '/campaigns/invitations/pay-bill',
      element: <PayBill />
    },
    {
      path: '/campaigns/invitations/verification-code',
      element: <Verification />
    },
    {
      path: '/campaigns/invitations/enter-code',
      element: <EnterCode />
    },
    {
      path: '/campaigns/invitations/verification-success',
      element: <VerificationSuccess />
    },
    {
      path: '/campaigns/invitations/verification-result',
      element: <VerificationResult />
    },
    {
      path: '/campaigns/invitations/pending-orders',
      element: <PendingOrders />
    },
    {
      path: '/campaigns/invitations/verification-history',
      element: <VerificationHistory />
    },
    {
      path: '/campaigns/invitations/withdraw-list',
      element: <WithdrawList />
    },
    {
      path: '/campaigns/invitations/withdraw-detail',
      element: <WithdrawDetail />
    }
  ]
};